export const header: HeaderSetup = {
    background: 'linear-gradient(137deg, #FFF 260px, transparent 260px), #ffe6b4',
    backgroundMobile: '#ffe6b4',
    foreground: null,
    logo: '/assets/kromatic-black.svg',
    logoLink: null,
    logoMobile: '/favicon.png',
    tagline: 'a.k.a Decision Making in Uncertainty',
    textOffset: 115,
    title: 'Startup Poker',
};
